import { SPACE_BYPASS_2FA } from "@/configs/runtime";
import { inferIsSpaceUser } from "../../../../utils/utilitariosJwt";

// ------------------------------- FUNCTIONS -------------------------------
export function ehIdentificadorCpf(usuario: string): boolean {
	return /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/.test(usuario.trim());
}

export function obterModoLoginUnificado(usuario: string): "senha" | "otp-space" {
	if (!SPACE_BYPASS_2FA && inferIsSpaceUser({ username: usuario })) return "otp-space";
	return "senha";
}
